import Axios from "axios";
import _ from 'lodash'

const defaultState = () => {
  return {
    id: null,
    attributes: {
      name: "",
      widget_types: [],
      index_column: null,
      groupable_by_date: null,
      service_class: "",
      data_source: "",
      table_columns: []
    }
  }
}

const state = {
  metric: defaultState()
}

const getters = {
  metricSIndexColumns (state) {
    return state.metric.attributes.table_columns
  },

  metric (state) {
    return state.metric
  }
}

const mutations = {
  setDefaultMetric(state) {
    _.set(state, 'metric', defaultState())
  },

  setMetric(state, params) {
    let metric = Object.assign({}, state.metric, params)
    _.set(state, 'metric', metric)
  },

  updateMetricAttributes(state, params) {
    let attributes = Object.assign({}, state.metric.attributes, params)
    _.set(state, 'metric.attributes', attributes)
  },

}

const actions = {
  async submitMetricChanges({state}) {
    try {
      const payload = {metric: {index_column: state.metric.attributes.index_column}}
      await Axios.put(`/metrics/${state.metric.id}`, payload)
    }
    catch (e) {
      return e
    }
  },
  async loadMetric ({commit}, id) {
    try {
      const payload = await Axios.get(`/metrics/${id}`)
      commit('setMetric', payload.data.data)
    }
    catch (e) {
      return console.log(e)
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
